import { GoogleMap, Marker } from "@react-google-maps/api";
import { Location } from "types/Shop";

type Props = {
  location: Location;
};

export default function TransportDriverLastLocationMap({ location }: Props) {
  if (!location) {
    return null;
  }

  const lastLocation = {
    lat: location.coordinates[1],
    lng: location.coordinates[0],
  };

  return (
    <GoogleMap center={lastLocation} zoom={15} mapContainerStyle={{ height: "700px", width: "100%" }}>
      {lastLocation && <Marker position={lastLocation} />}
    </GoogleMap>
  );
}
